export function formatCurrency(value: number | null | undefined): string {
  if (value == null) return '--';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatCurrencyCents(value: number | null | undefined): string {
  if (value == null) return '--';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatNumber(value: number | null | undefined): string {
  if (value == null) return '--';
  return new Intl.NumberFormat('en-US').format(value);
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null) return '--';
  return `${value >= 0 ? '+' : ''}${value.toFixed(1)}%`;
}

export const SEVERITY_STYLES: Record<string, { bg: string; color: string }> = {
  high: { bg: 'var(--danger-light, #fee2e2)', color: 'var(--danger, #dc2626)' },
  medium: { bg: 'var(--warning-light, #fef3c7)', color: 'var(--warning, #d97706)' },
  low: { bg: 'var(--success-light, #dcfce7)', color: 'var(--success, #16a34a)' },
};

export function getScoreColor(score: number): string {
  if (score >= 8) return 'var(--success, #16a34a)';
  if (score >= 6) return 'var(--warning, #d97706)';
  return 'var(--danger, #dc2626)';
}

export function getVerdictBorderColor(verdict?: string): string {
  if (verdict === 'strong_go') return 'var(--success, #16a34a)';
  if (verdict === 'no_go') return 'var(--danger, #dc2626)';
  return 'var(--warning, #d97706)';
}

export function getValueColor(value: number, thresholds: { good: number; warn: number }): string {
  if (value >= thresholds.good) return 'var(--success)';
  if (value >= thresholds.warn) return 'var(--warning)';
  return 'var(--danger)';
}

export function getSignColor(value: number): string {
  return value >= 0 ? 'var(--success)' : 'var(--danger)';
}

export function sourceTypeLabel(st: string): string {
  const labels: Record<string, string> = {
    budget_template: 'Budget Template',
    production_schedule: 'Production Schedule',
    coconstruct_estimate: 'CoConstruct Estimate',
    actual_costs: 'Actual Costs',
    pdf_estimate: 'PDF Estimate',
  };
  return labels[st] || st;
}
